import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Button } from "@/components/ui/button";

export const ExportButtons = ({ path, params = {}, csv = true, testid = "export" }) => {
  const { t } = useLang();
  const [busy, setBusy] = useState("");
  const dl = async (fmt) => {
    setBusy(fmt);
    try {
      const res = await api.get(path, { params: { ...params, fmt }, responseType: "blob" });
      const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || `export.${fmt}`;
      const url = URL.createObjectURL(res.data);
      const a = Object.assign(document.createElement("a"), { href: url, download: name });
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy("");
  };
  return (
    <div className="flex gap-2">
      <Button variant="outline" size="sm" data-testid={`${testid}-xlsx-btn`} disabled={!!busy} onClick={() => dl("xlsx")}>
        {busy === "xlsx" ? <Loader2 className="me-1 h-4 w-4 animate-spin" /> : <Download className="me-1 h-4 w-4" />}Excel
      </Button>
      {csv && (
        <Button variant="outline" size="sm" data-testid={`${testid}-csv-btn`} disabled={!!busy} onClick={() => dl("csv")}>
          {busy === "csv" ? <Loader2 className="me-1 h-4 w-4 animate-spin" /> : <Download className="me-1 h-4 w-4" />}CSV
        </Button>
      )}
      <span className="sr-only">{t("export")}</span>
    </div>
  );
};
